import { Box, BoxProps, Stack, StackProps, type SxProps } from "@mui/material";

type LoadingProps = {
  label?: string;
  size?: BoxProps["width"];
  containerWidth?: StackProps["width"];
  styles?: SxProps;
};

/** Loading spinner */
const Loading = ({
  styles,
  label = "",
  size = "4rem",
  containerWidth = "100%",
}: LoadingProps) => (
  <Stack
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: containerWidth,
      ...styles,
    }}
  >
    <Box
      component="img"
      src="/loading.gif"
      alt={`Loading indicator${label ? ` for ${label}` : ""}`}
      sx={{ width: size }}
    />
  </Stack>
);
export default Loading;
